'use client';
import React, { useEffect, useRef } from 'react';
import Navbar from "@/components/ui/Navbar";

// --- Integrated Components ---
import MarketingServicesSection from "./components/MarketingServicesSection";
import Footer from "./components/Footer";

const StrategySection = () => {
  return (
    <>
      <style dangerouslySetInnerHTML={{
        __html: `
                .strategy-grid {
                    display: grid;
                    grid-template-columns: 1fr;
                    gap: 60px;
                }
                .strategy-heading-text {
                    font-size: clamp(2.5rem, 5vw, 4.5rem);
                    line-height: 1.05;
                    color: #FFFFE3;
                    text-transform: none;
                    margin-bottom: 0;
                }
                .strategy-desc-text {
                    font-size: 1.125rem;
                    line-height: 1.6;
                    color: #BBB;
                    max-width: 400px;
                }
                .strategy-list-item {
                    font-size: 1.125rem;
                    color: #DDD;
                    padding: 30px 0;
                    border-top: 1px solid rgba(255,255,255,0.15);
                    display: flex;
                    align-items: center;
                }
                .strategy-list-item:last-child {
                    border-bottom: 0;
                }
                .strategy-list-container {
                    border-bottom: 1px solid rgba(255,255,255,0.15);
                }
                .strategy-btn {
                    margin-top: 60px;
                    display: inline-block;
                    padding: 20px 48px;
                    background-color: #EDFFA6;
                    color: #000;
                    border-radius: 100px;
                    text-decoration: none;
                    font-weight: 500;
                    font-size: 1.125rem;
                    transition: transform 0.2s ease;
                }
                .strategy-btn:hover {
                    transform: scale(1.05);
                }
                
                .strategy-wrapper {
                    background-color: #070707;
                    position: relative;
                    z-index: 10;
                    width: 100%;
                    padding-top: 100px;
                    padding-bottom: 150px;
                }
                @media (max-width: 767px) {
                    .strategy-wrapper {
                        padding-top: 40px;
                        padding-bottom: 80px;
                    }
                }

                @media (min-width: 992px) {
                    .strategy-grid {
                        grid-template-columns: 1.15fr 0.85fr;
                        grid-template-rows: auto auto;
                        column-gap: 80px;
                        row-gap: 80px;
                    }
                    .strategy-heading-area { grid-column: 1; grid-row: 1; }
                    .strategy-text-area { grid-column: 2; grid-row: 1; display: flex; align-items: start; padding-top: 60px; }
                    .strategy-image-area { grid-column: 1; grid-row: 2; }
                    .strategy-list-area { grid-column: 2; grid-row: 2; display: flex; flex-direction: column; justify-content: flex-start; }
                }
            `}} />

      <div className="strategy-wrapper">
        <section className="section_strategy u-container" style={{ color: '#fff' }}>
          <div className="strategy-grid">

            <div className="strategy-heading-area">
              <h2 className="u-text-style-display strategy-heading-text">
                The web, <br />
                reimagined.
              </h2>
            </div>

            <div className="strategy-text-area">
              <p className="u-text-style-h4 strategy-desc-text">
                We build digital platforms that are as beautiful as they are functional. Fast, secure, and scalable solutions for the modern web.
              </p>
            </div>

            <div className="strategy-image-area">
              <div style={{
                borderRadius: '32px',
                overflow: 'hidden',
                width: '100%',
                height: '520px',
                position: 'relative',
                backgroundColor: '#1a1a1a'
              }}>
                <img
                  src="/images/web_strategy.png"
                  alt="Web Development Strategy"
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
            </div>

            <div className="strategy-list-area">
              <div className="strategy-list-container">
                {[
                  'Pixel-perfect responsive interfaces',
                  'Scalable server-side solutions',
                  'High-conversion online stores',
                  'Seamless CMS integration'
                ].map((item, index) => (
                  <div key={index} className="strategy-list-item">
                    <div style={{
                      width: '6px',
                      height: '6px',
                      borderRadius: '50%',
                      backgroundColor: '#666',
                      marginRight: '24px',
                      flexShrink: 0
                    }}></div>
                    {item}
                  </div>
                ))}
              </div>

            </div> {/* Close strategy-list-area */}
          </div> {/* Close strategy-grid */}
        </section>
      </div>
    </>
  );
};

const OverviewSection = () => {
  return (
    <section className="about_wrap" style={{ marginTop: '100px', marginBottom: '100px' }}>
      <div className="about_p3_contain u-flex-vertical-nowrap">
        <div className="about_p3_wrap u-flex-vertical-nowrap u-gap-8 u-width-full">
          <div className="eyebrow_wrap u-mb-5">
            <div className="eyebrow_layout">
              <div data-pulse="" className="eyebrow_marker"></div>
              <div className="u-mono w-richtext">
                <p>OUR MISSION & VISION</p>
              </div>
            </div>
          </div>
          <h2 data-split="heading" className="colors_heading u-text-style-h2">
            <span className="text-span-3">
              We design, build, and scale digital products that make an impact. Our multidisciplinary team combines creativity and technology to deliver measurable growth.
            </span>
          </h2>
        </div>
      </div>
    </section>
  );
};



const StickyServices = () => {
  return (
    <section className="sticky-services-section" data-header-theme="dark">
      <style dangerouslySetInnerHTML={{
        __html: `
          .sticky-services-section {
            background-color: #fff !important;
            color: #000 !important;
          }
          .sticky-services-section .sticky-card-wrap {
            position: -webkit-sticky !important;
            position: sticky !important;
            top: 80px !important;
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
            will-change: transform;
          }
          .sticky-services-section .sticky-card {
            background-color: #fff !important;
            color: #000 !important;
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
            box-shadow: 0 -10px 30px rgba(0, 0, 0, 0.05);
          }
          .sticky-services-section h2, 
          .sticky-services-section p, 
          .sticky-services-section li,
          .sticky-services-section div {
            color: #000 !important;
          }
          .sticky-services-section .u-opacity-60, 
          .sticky-services-section .u-opacity-80 {
            opacity: 1 !important;
            color: #333 !important;
          }
          .service-bubbles {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
            margin-top: 24px;
          }
          .service-bubble {
            padding: 8px 16px;
            border-radius: 50px;
            background-color: #f5f5f7;
            border: 1px solid #dcdcdc;
            color: #333;
            font-size: 0.875rem;
            font-weight: 500;
            white-space: nowrap;
          }
          @media (max-width: 991px) {
            .sticky-services-section .services_item {
              display: flex;
              flex-direction: column;
              gap: 20px;
              padding: 24px 0;
            }
            .sticky-services-section .services_item > div {
              width: 100% !important;
              margin: 0 !important;
            }
            .sticky-services-section .services_image_wrap {
              margin-top: 20px !important;
            }
            .sticky-services-section h2.u-margin-bottom-4 {
              font-size: 2rem !important;
            }
          }
        `
      }} />
      <div data-wf--content-wrapper--alignment="inherit" className="u-display-contents">
        <div className="u-content-wrapper u-zindex-3 u-container">

          {/* Service 01: Frontend Engineering */}
          <div data-home-service="" className="sticky-card-wrap" style={{ opacity: 1, zIndex: 11 }}>
            <div className="sticky-card" style={{ backgroundColor: '#fff', color: '#000' }}>
              <div className="services_item u-grid-custom">
                <div className="services_number_wrap u-column-1">
                  <div className="u-opacity-60">01</div>
                </div>
                <div className="services_heading_wrap u-column-4">
                  <div>
                    <h2 className="u-text-style-h3 u-margin-bottom-4">Frontend Engineering</h2>
                    <div className="u-rich-text u-opacity-80 w-richtext">
                      <ul role="list">
                        <li>Pixel-perfect React and Next.js interfaces</li>
                        <li>High-performance, responsive applications</li>
                      </ul>
                      <div className="service-bubbles">
                        {['React', 'Next.js', 'Typescript', 'Tailwind CSS', 'Framer Motion', 'GSAP', 'Three.js', 'WebGL'].map(tag => (
                          <span key={tag} className="service-bubble">{tag}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="services_image_wrap u-column-6">
                  <img
                    src="/zeit/images/d22qEyRAhrxv.avif"
                    loading="lazy"
                    width="698"
                    height="393"
                    alt=""
                    sizes="(max-width: 767px) 100vw, 698px"
                    srcSet="/zeit/images/dkTIizS0PmoA.avif 500w, /zeit/images/KCcrPl6BYbxk.avif 800w, /zeit/images/pSWo1bmKmYaY.avif 1080w, /zeit/images/d22qEyRAhrxv.avif 1396w"
                    className="services_image"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Service 02: Backend Architecture */}
          <div data-home-service="" className="sticky-card-wrap" style={{ opacity: 1, zIndex: 12 }}>
            <div className="sticky-card" style={{ backgroundColor: '#fff', color: '#000' }}>
              <div className="services_item u-grid-custom">
                <div className="services_number_wrap u-column-1">
                  <div className="u-opacity-60">02</div>
                </div>
                <div className="services_heading_wrap u-column-4">
                  <div>
                    <h2 className="u-text-style-h3 u-margin-bottom-4">Backend Architecture</h2>
                    <div className="u-rich-text u-opacity-80 w-richtext">
                      <ul role="list">
                        <li>Scalable server-side solutions with Node.js</li>
                        <li>Secure API development and database management</li>
                      </ul>
                      <div className="service-bubbles">
                        {['Node.js', 'Python', 'Go', 'PostgreSQL', 'MongoDB', 'Redis', 'Docker', 'Kubernetes'].map(tag => (
                          <span key={tag} className="service-bubble">{tag}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="services_image_wrap u-column-6">
                  <img
                    src="/zeit/images/ab59kXPcZ781.avif"
                    loading="lazy"
                    width="698"
                    height="393"
                    alt=""
                    sizes="(max-width: 767px) 100vw, 698px"
                    srcSet="/zeit/images/jkXHw5bbjaeD.avif 500w, /zeit/images/b7V7Ud8heaUq.avif 800w, /zeit/images/zbnyADW6t7jV.avif 1080w, /zeit/images/ab59kXPcZ781.avif 1396w"
                    className="services_image"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Service 03: E-Commerce */}
          <div data-home-service="" className="sticky-card-wrap" style={{ opacity: 1, zIndex: 13 }}>
            <div className="sticky-card" style={{ backgroundColor: '#fff', color: '#000' }}>
              <div className="services_item u-grid-custom">
                <div className="services_number_wrap u-column-1">
                  <div className="u-opacity-60">03</div>
                </div>
                <div className="services_heading_wrap u-column-4">
                  <div>
                    <h2 className="u-text-style-h3 u-margin-bottom-4">E-Commerce</h2>
                    <div className="u-rich-text u-opacity-80 w-richtext">
                      <ul role="list">
                        <li>High-conversion online stores</li>
                        <li>Seamless checkout and payment integration</li>
                      </ul>
                      <div className="service-bubbles">
                        {['Shopify', 'Stripe', 'WooCommerce', 'Payment Gateways', 'Order Management', 'Cart Logic'].map(tag => (
                          <span key={tag} className="service-bubble">{tag}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="services_image_wrap u-column-6">
                  <img
                    src="/zeit/images/0hsTvVtxKOMA.avif"
                    loading="lazy"
                    width="698"
                    height="393"
                    alt=""
                    sizes="(max-width: 767px) 100vw, 698px"
                    srcSet="/zeit/images/1QmAbKeHTKho.avif 500w, /zeit/images/25t7sUAfi2kA.avif 800w, /zeit/images/qWSQInIEjOH8.avif 1080w, /zeit/images/0hsTvVtxKOMA.avif 1396w"
                    className="services_image"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Service 04: CMS & Integration */}
          <div data-home-service="" className="sticky-card-wrap" style={{ opacity: 1, zIndex: 14 }}>
            <div className="sticky-card" style={{ backgroundColor: '#fff', color: '#000' }}>
              <div className="services_item u-grid-custom">
                <div className="services_number_wrap u-column-1">
                  <div className="u-opacity-60">04</div>
                </div>
                <div className="services_heading_wrap u-column-4">
                  <div>
                    <h2 className="u-text-style-h3 u-margin-bottom-4">CMS & Integration</h2>
                    <div className="u-rich-text u-opacity-80 w-richtext">
                      <ul role="list">
                        <li>Headless CMS implementation</li>
                        <li>Third-party service integrations</li>
                      </ul>
                      <div className="service-bubbles">
                        {['Sanity', 'Contentful', 'Strapi', 'REST API', 'GraphQL', 'Third-party APIs', 'Zapier'].map(tag => (
                          <span key={tag} className="service-bubble">{tag}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="services_image_wrap u-column-6">
                  <img
                    src="/zeit/images/z01fMVY4I5jy.avif"
                    loading="lazy"
                    width="698"
                    height="393"
                    alt=""
                    sizes="(max-width: 767px) 100vw, 698px"
                    srcSet="/zeit/images/O40pAFZOVI5Z.avif 500w, /zeit/images/cklXUn1uRkru.avif 800w, /zeit/images/ujQeOlg9q4UA.avif 1080w, /zeit/images/z01fMVY4I5jy.avif 1396w"
                    className="services_image"
                  />
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

const CtaSection = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    // Canvas logic would go here.
    // If there is a global script that initializes #canvas3d, it might run automatically
    // or need manual initialization. 
  }, []);

  return (
    <section id="section_cta" className="section_cta u-section" data-header-theme="dark">
      <style dangerouslySetInnerHTML={{
        __html: `
          #section_cta.section_cta {
            background-color: #fff !important;
            color: #000 !important;
          }
          #section_cta .cta_wrap {
            position: relative;
            z-index: 10 !important;
            mix-blend-mode: normal !important;
          }
          #section_cta ._3d_heading_wrap {
            z-index: 10 !important;
          }
          #section_cta ._3d_heading {
            color: #000 !important;
            -webkit-text-fill-color: #000 !important;
            -webkit-text-stroke: 0px !important; 
            mix-blend-mode: normal !important;
            opacity: 1 !important;
          }
          #section_cta ._3d_canvas {
             background-color: transparent !important;
             z-index: 1 !important;
          }
          #section_cta ._3d_absolute_mobile {
             filter: invert(1) !important;
             mix-blend-mode: multiply !important;
             width: 100%;
             height: 100%;
             object-fit: cover;
             -webkit-transform: translate3d(0, 0, 0);
             transform: translate3d(0, 0, 0);
             will-change: filter, mix-blend-mode;
          }
          @media (max-width: 767px) {
            #section_cta ._3d_heading {
              font-size: 14vw !important;
            }
            #section_cta .cta_wrap {
              padding: 60px 20px !important;
            }
          }
        `
      }} />
      <div className="cta_wrap u-container">
        <div className="_3d_heading_wrap">
          <div className="_3d_heading">Let's</div>
          <div className="_3d_heading">Create</div>
        </div>
        <div className="_3d_heading_wrap">
          <div className="_3d_heading">Something</div>
        </div>
        <div className="_3d_heading_wrap is-last">
          <div className="_3d_heading">Extraordinary</div>
        </div>
      </div>
      <div className="_3d_wrap">
        <div className="_3d_canvas">
          <canvas
            id="canvas3d"
            ref={canvasRef}
            className="_3d_absolute hide-mobile"
            width={1055}
            height={1055}
            style={{ display: 'block', width: '100%', height: '100%' }}
          />
          <video
            src="/zeit/media/ONVXjlcjbogZ.mp4"
            autoPlay
            loop
            muted
            playsInline
            className="_3d_absolute_mobile"
            style={{}}
          />
        </div>
      </div>
    </section>
  );
};

// --- Main Page Component ---

export default function WebDevelopmentPage() {
  useEffect(() => {
    let ctx: any;
    let split: any;
    let active = true;
    let timeoutId: NodeJS.Timeout;

    const init = () => {
      if (!active) return;
      const w = window as any;
      if (!w.gsap || !w.SplitText || !w.ScrollTrigger) {
        timeoutId = setTimeout(init, 100);
        return;
      }
      const gsap = w.gsap;
      const SplitText = w.SplitText;

      const titleElement = document.querySelector('[data-home-client-title]');
      if (!titleElement || titleElement.getAttribute('data-anim-init')) return;

      ctx = gsap.context(() => {
        titleElement.setAttribute('data-anim-init', 'true');

        split = new SplitText(titleElement.querySelectorAll("p"), {
          type: "words,chars",
          wordsClass: "word"
        });
        const words = split.words;

        const isMobileOrTablet = window.innerWidth < 1024;

        if (isMobileOrTablet) {
          // Clean 2D animation on mobile/tablet to prevent WebKit GPU texture blank bugs
          gsap.fromTo(words, {
            opacity: 0,
            y: 20
          }, {
            opacity: 1,
            y: 0,
            ease: "power2.out",
            scrollTrigger: {
              trigger: titleElement,
              start: "top 90%",
              end: "bottom 30%",
              scrub: true,
              invalidateOnRefresh: true
            },
            stagger: 0.005
          });
        } else {
          // Premium 3D animation for desktop
          const parents = new Set();
          words.forEach((word: any) => parents.add(word.parentNode));
          parents.forEach((parent: any) => gsap.set(parent, { perspective: 1000 }));

          gsap.fromTo(words, {
            "will-change": "opacity, transform",
            z: () => gsap.utils.random(500, 950),
            opacity: 0,
            xPercent: () => gsap.utils.random(-100, 100),
            yPercent: () => gsap.utils.random(-10, 10),
            rotationX: () => gsap.utils.random(-90, 90)
          }, {
            ease: "expo",
            opacity: 1,
            rotationX: 0,
            rotationY: 0,
            xPercent: 0,
            yPercent: 0,
            z: 0,
            scrollTrigger: {
              trigger: titleElement,
              start: "top 80%",
              end: "bottom 20%",
              scrub: 1,
              invalidateOnRefresh: true
            },
            stagger: {
              each: 0.006,
              from: "random"
            }
          });
        }

        // Refresh ScrollTrigger to account for any layout shifts
        setTimeout(() => {
          if (w.ScrollTrigger) {
            w.ScrollTrigger.refresh();
          }
        }, 1000);
      });
    };

    init();

    return () => {
      active = false;
      clearTimeout(timeoutId);
      if (ctx) ctx.revert();
      if (split) split.revert();
      const titleElement = document.querySelector('[data-home-client-title]');
      if (titleElement) titleElement.removeAttribute('data-anim-init');
    };
  }, []);

  useEffect(() => {
    let ctx: any;
    let splitWords: any;
    let wList: any[] = [];
    let initialSplit: any;
    let active = true;
    let timeoutId: NodeJS.Timeout;

    const init = () => {
      if (!active) return;
      const w = window as any;
      if (!w.gsap || !w.SplitText || !w.ScrollTrigger) {
        timeoutId = setTimeout(init, 100);
        return;
      }
      const gsap = w.gsap;
      const SplitText = w.SplitText;

      // Animate Overview Heading
      const headingElement = document.querySelector('[data-split="heading"]');
      if (headingElement && !headingElement.getAttribute('data-anim-init')) {
        ctx = gsap.context(() => {
          headingElement.setAttribute('data-anim-init', 'true');

          // Split by words
          initialSplit = new SplitText(headingElement, { type: "words,lines", linesClass: "words-split-mask" });
          const words = initialSplit.words;

          gsap.from(words, {
            duration: 1,
            y: "100%",
            ease: "power3.out",
            stagger: 0.02,
            scrollTrigger: {
              trigger: headingElement,
              start: "top 85%"
            }
          });

          initialSplit.revert();
          splitWords = new SplitText(headingElement, { type: "words", wordsClass: "words-split" });
          wList = splitWords.words;

          // Wrap each word in a mask div manually
          wList.forEach((word: any) => {
            try {
              if (word && word instanceof Node && word.parentNode) {
                const wrapper = document.createElement('div');
                wrapper.className = 'words-split-mask';
                wrapper.style.display = 'inline-block';
                wrapper.style.overflow = 'hidden';
                wrapper.style.verticalAlign = 'bottom'; // Fix baseline alignment

                word.parentNode.insertBefore(wrapper, word);
                wrapper.appendChild(word);
              }
            } catch (err) {
              console.error('GSAP Init insertBefore wrapper error:', err);
            }
          });

          gsap.from(wList, {
            y: "100%",
            duration: 0.8,
            ease: "power2.out",
            stagger: 0.015,
            scrollTrigger: {
              trigger: headingElement,
              start: "top 80%"
            }
          });
        });
      }
    };

    init();

    return () => {
      active = false;
      clearTimeout(timeoutId);

      // Cleanup custom masks out of wList elements first, if they exist
      if (wList && wList.length > 0) {
        wList.forEach((word: any) => {
          try {
            if (word && word instanceof Node && word.parentNode) {
              const parent = word.parentNode as HTMLElement;
              if (parent && parent.className === 'words-split-mask' && parent.parentNode && (parent.parentNode instanceof Node) && (word instanceof Node)) {
                parent.parentNode.insertBefore(word, parent);
                parent.parentNode.removeChild(parent);
              }
            }
          } catch (err) {
            console.error('GSAP Cleanup mask revert error:', err);
          }
        });
      }

      // Revert initialSplits
      if (splitWords) splitWords.revert();
      if (initialSplit && !splitWords) initialSplit.revert();

      if (ctx) ctx.revert();
      const headingElement = document.querySelector('[data-split="heading"]');
      if (headingElement) headingElement.removeAttribute('data-anim-init');
    };
  }, []);

  return (
    <>
      <Navbar />
      <div dangerouslySetInnerHTML={{
        __html: `<style>
    html.lenis,
    html.lenis body {
      height: auto;
    }

    ::-webkit-scrollbar {
      display: none !important;
      visibility: none !important;
      width: 0px !important;
    }

    .lenis.lenis-smooth {
      scroll-behavior: auto !important;
      overscroll-behavior: contain;
    }

    .lenis.lenis-smooth [data-lenis-prevent] {
      overscroll-behavior: contain;
    }

    .lenis.lenis-stopped {
      overflow: hidden;
    }

    .lenis.lenis-smooth iframe {
      pointer-events: none;
    }

    /* Utility Classes */
    .overflow-hidden {
      overflow: hidden;
    }


    .lines-split,
    .chars-split,
    .words-split {
      padding-bottom: 0.04em;
    }

    .hero-heading {
      font-size: 10vw;
    }

    .featured-clients-wrapper {
      min-height: 200vh;
    }

    .section_home_client {
      position: -webkit-sticky !important;
      position: sticky !important;
    }

    .hero_info_about {
      display: flex;
      flex-direction: column;
      gap: 40px;
      margin-top: 40px;
    }

    @media (max-width: 767px) {
      .hero_contain {
        justify-content: flex-start !important;
        padding-top: 15vh !important;
        gap: 6vh !important;
      }
      .hero-heading {
        font-size: 12vw !important;
        margin-top: 0 !important;
      }
      .hero_bottom_wrap {
        flex-direction: column !important;
        background-color: rgba(7, 7, 7, 0.4);
        padding: 20px;
        border-radius: 16px;
        backdrop-filter: blur(10px);
      }
      .hero_info_about {
        flex-direction: column !important;
        gap: 20px !important;
      }
      .hero_info_contain {
        flex-direction: column !important;
        align-items: flex-start !important;
        gap: 8px !important;
      }
      .hero_info_strokes_wrap {
        flex-direction: row !important;
        flex-wrap: nowrap !important;
        gap: 10px !important;
      }
      .featured-clients-wrapper {
        min-height: auto !important;
      }
      .section_home_client {
        min-height: auto !important;
        position: relative !important;
        padding-top: 15vh !important;
        padding-bottom: 40px !important;
        justify-content: flex-start !important;
        gap: 20px !important;
      }
      .section_home_client .u-align-items-center {
        align-items: flex-start !important;
      }
      .eyebrow_wrap {
        display: flex !important;
        visibility: visible !important;
        margin-bottom: 15px !important;
      }
    }

  </style>`}} />
      <div className="gtag-embed w-embed w-iframe">{/*  Google Tag Manager (noscript)  */}
        <noscript><iframe src="INSERT-GTAG-SRC-LINK-HERE" height="0" width="0"
          style={{ display: "none", visibility: "hidden" }}></iframe></noscript>
        {/*  End Google Tag Manager (noscript)  */}
      </div>
      <div className="u-position-fixed">
        <div className="w-embed" dangerouslySetInnerHTML={{
          __html: `<style>
          :root {
            --grid-breakout: [full-start] minmax(0, 1fr) [content-start] repeat(var(--site--column-count), minmax(0, var(--site--column-width))) [content-end] minmax(0, 1fr) [full-end];
            --grid-breakout-single: [full-start] minmax(0, 1fr) [content-start] minmax(0, calc(100% - var(--site--margin) * 2)) [content-end] minmax(0, 1fr) [full-end];

            --column-width--1: calc((100% - ((var(--site--column-count) - 1) * var(--site--gutter))) / var(--site--column-count));
            --column-width--2: calc(var(--column-width--1) * 2 + (var(--site--gutter) * 1));
            --column-width--3: calc(var(--column-width--1) * 3 + (var(--site--gutter) * 2));
            --column-width--4: calc(var(--column-width--1) * 4 + (var(--site--gutter) * 3));
            --column-width--5: calc(var(--column-width--1) * 5 + (var(--site--gutter) * 4));
            --column-width--6: calc(var(--column-width--1) * 6 + (var(--site--gutter) * 5));
            --column-width--7: calc(var(--column-width--1) * 7 + (var(--site--gutter) * 6));
            --column-width--8: calc(var(--column-width--1) * 8 + (var(--site--gutter) * 7));
            --column-width--9: calc(var(--column-width--1) * 9 + (var(--site--gutter) * 8));
            --column-width--10: calc(var(--column-width--1) * 10 + (var(--site--gutter) * 9));
            --column-width--11: calc(var(--column-width--1) * 11 + (var(--site--gutter) * 10));
            --column-width--12: calc(var(--column-width--1) * 12 + (var(--site--gutter) * 11));

            --column-margin--1: calc(var(--column-width--1) + var(--site--gutter));
            --column-margin--2: calc(var(--column-width--2) + var(--site--gutter));
            --column-margin--3: calc(var(--column-width--3) + var(--site--gutter));
            --column-margin--4: calc(var(--column-width--4) + var(--site--gutter));
            --column-margin--5: calc(var(--column-width--5) + var(--site--gutter));
            --column-margin--6: calc(var(--column-width--6) + var(--site--gutter));
            --column-margin--7: calc(var(--column-width--7) + var(--site--gutter));
            --column-margin--8: calc(var(--column-width--8) + var(--site--gutter));
            --column-margin--9: calc(var(--column-width--9) + var(--site--gutter));
            --column-margin--10: calc(var(--column-width--10) + var(--site--gutter));
            --column-margin--11: calc(var(--column-width--11) + var(--site--gutter));
            --column-margin--12: calc(var(--column-width--12) + var(--site--gutter));

          }

          ::before,
          ::after {
            box-sizing: border-box;
          }

          .w-embed:before,
          .w-embed:after,
          .w-richtext:before,
          .w-richtext:after {
            content: unset;
          }





          /* Selection Color */
          ::selection {
            background-color: var(--_theme---selection--background);
            color: var(--_theme---selection--text);
          }

          /* Margin Trim */
          :is(.u-margin-trim, .u-rich-text)> :not(:not(.w-condition-invisible) ~ :not(.w-condition-invisible)),
          :is(.u-margin-trim, .u-rich-text)> :not(:not(.w-condition-invisible) ~ :not(.w-condition-invisible)).u-display-contents> :first-child {
            margin-top: 0;
          }

          :is(.u-margin-trim, .u-rich-text)> :not(:has(~ :not(.w-condition-invisible))),
          :is(.u-margin-trim, .u-rich-text)> :not(:has(~ :not(.w-condition-invisible))).u-display-contents> :last-child {
            margin-bottom: 0;
          }

          /* Line Height Trim */
          :is([class*="u-text-style-"], h1, h2, h3, h4, h5, h6, p):not(.w-richtext, .u-text-trim-off)::before {
            content: "";
            display: table;
            margin-bottom: calc(-0.5lh + var(--_text-style---trim-top));
          }

          :is([class*="u-text-style-"], h1, h2, h3, h4, h5, h6, p):not(.w-richtext, .u-text-trim-off)::after {
            content: "";
            display: table;
            margin-bottom: calc(-0.5lh + var(--_text-style---trim-bottom));
          }

          /* Rich Text Links */
          .w-richtext a {
            position: relative;
            z-index: 4;
          }

          /* Line Clamp */
          .u-line-clamp-1,
          .u-line-clamp-2,
          .u-line-clamp-3,
          .u-line-clamp-4 {
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }

          .u-line-clamp-2 {
            -webkit-line-clamp: 2;
          }

          .u-line-clamp-3 {
            -webkit-line-clamp: 3;
          }

          .u-line-clamp-4 {
            -webkit-line-clamp: 4;
          }

          /* Child Contain */
          .u-child-contain>* {
            width: 100%;
            max-width: inherit !important;
            margin-inline: 0 !important;
            margin-top: 0 !important;
          }

          /* Hide */
          .u-hide-if-empty:empty,
          .u-hide-if-empty:not(:has(> :not(.w-condition-invisible))),
          .u-hide-if-empty-cms:not(:has(.w-dyn-item)),
          .u-embed-js,
          .u-embed-css {
            display: none !important;
          }

          /* Focus State */
          a,
          button,
          :where([tabindex]),
          [data-outline] {
            outline-offset: var(--focus--offset-outer);
          }

          a:focus-visible,
          button:focus-visible,
          [tabindex]:focus-visible,
          label:has(input:focus-visible) [data-outline] {
            outline-color: var(--_theme---text);
            outline-width: var(--focus--width);
            outline-style: solid;
          }

          /* Global / Clickable Component */
          .wf-design-mode .clickable_wrap {
            z-index: 0;
          }

          .clickable_wrap a[href="#"] {
            display: none;
          }

          .clickable_wrap a[href="#"]~button {
            display: block;
          }

          /* Responsive Above */
          @container threshold-large (width >=62em) {
            .u-order-unset-above {
              order: unset !important;
            }

            .u-all-unset-above {
              all: unset !important;
            }

            .u-grid-below {
              display: flex !important;
            }
          }

          @container threshold-medium (width >=48em) {
            .u-order-unset-above {
              order: unset !important;
            }

            .u-all-unset-above {
              all: unset !important;
            }

            .u-grid-below {
              display: flex !important;
            }
          }

          @container threshold-small (width >=30em) {
            .u-order-unset-above {
              order: unset !important;
            }

            .u-all-unset-above {
              all: unset !important;
            }

            .u-grid-below {
              display: flex !important;
            }
          }

          /* Responsive Below */
          @container threshold-large (width < 62em) {
            .u-order-unset-below {
              order: unset !important;
            }

            .u-all-unset-below {
              all: unset !important;
            }

            .u-grid-above {
              display: flex !important;
            }
          }

          @container threshold-medium (width < 48em) {
            .u-order-unset-below {
              order: unset !important;
            }

            .u-all-unset-below {
              all: unset !important;
            }

            .u-grid-above {
              display: flex !important;
            }
          }

          @container threshold-small (width < 30em) {
            .u-order-unset-below {
              order: unset !important;
            }

            .u-all-unset-below {
              all: unset !important;
            }

            .u-grid-above {
              display: flex !important;
            }
          }

          /* Form Radio */
          .form_main_radio_label:has(input:checked) .form_main_radio_circle_inner {
            opacity: 1;
          }

          /* Form Checkbox */
          .form_main_checkbox_label:has(input:checked) .form_main_checkbox_box {
            background-color: currentColor;
            border-color: currentColor;
          }

          .form_main_checkbox_label:has(input:checked) .form_main_checkbox_icon {
            opacity: 1;
          }
      </style>`
        }} />
        <div className="page_code_custom w-embed" dangerouslySetInnerHTML={{
          __html: `<style>
          /* Grid Layout */
          [data-column-span="1"] {
            grid-column: var(--span-1);
          }

          [data-column-span="2"] {
            grid-column: var(--span-2);
          }

          [data-column-span="3"] {
            grid-column: var(--span-3);
          }

          [data-column-span="4"] {
            grid-column: var(--span-4);
          }

          [data-column-span="5"] {
            grid-column: var(--span-5);
          }

          [data-column-span="6"] {
            grid-column: var(--span-6);
          }

          [data-column-span="7"] {
            grid-column: var(--span-7);
          }

          [data-column-span="8"] {
            grid-column: var(--span-8);
          }

          [data-column-span="9"] {
            grid-column: var(--span-9);
          }

          [data-column-span="10"] {
            grid-column: var(--span-10);
          }

          [data-column-span="11"] {
            grid-column: var(--span-11);
          }

          [data-column-span="12"] {
            grid-column: var(--span-12);
          }

          [data-column-start="1"] {
            grid-column-start: var(--start-1);
          }

          [data-column-start="2"] {
            grid-column-start: var(--start-2);
          }

          [data-column-start="3"] {
            grid-column-start: var(--start-3);
          }

          [data-column-start="4"] {
            grid-column-start: var(--start-4);
          }

          [data-column-start="5"] {
            grid-column-start: var(--start-5);
          }

          [data-column-start="6"] {
            grid-column-start: var(--start-6);
          }

          [data-column-start="7"] {
            grid-column-start: var(--start-7);
          }

          [data-column-start="8"] {
            grid-column-start: var(--start-8);
          }

          [data-column-start="9"] {
            grid-column-start: var(--start-9);
          }

          [data-column-start="10"] {
            grid-column-start: var(--start-10);
          }

          [data-column-start="11"] {
            grid-column-start: var(--start-11);
          }

          [data-column-start="12"] {
            grid-column-start: var(--start-12);
          }
      </style>`
        }} />
      </div >
      <div className="guide_wrap">
        <div className="w-embed" dangerouslySetInnerHTML={{
          __html: `<style>
          html.wf-design-mode .guide_wrap {
            display: block;
          }

          .guide_layout {
            counter-reset: gridguides;
          }

          .guide_layout>div::before {
            counter-increment: gridguides;
            content: counter(gridguides);
      </style>`
        }} />
        <div data-padding-bottom="none" data-padding-top="none" className="guide_contain u-container">
          <div className="guide_layout">
            <div className="guide_column"></div>
            <div className="guide_column"></div>
            <div className="guide_column"></div>
            <div className="guide_column"></div>
            <div className="guide_column"></div>
            <div className="guide_column"></div>
            <div className="guide_column"></div>
            <div className="guide_column"></div>
            <div className="guide_column"></div>
            <div className="guide_column"></div>
            <div className="guide_column"></div>
            <div className="guide_column"></div>
            <div className="guide_column"></div>
            <div className="guide_column"></div>
            <div className="guide_column"></div>
            <div className="guide_column"></div>
            <div className="guide_column"></div>
            <div className="guide_column"></div>
            <div className="guide_column"></div>
            <div className="guide_column"></div>
            <div className="guide_column"></div>
            <div className="guide_column"></div>
            <div className="guide_column"></div>
            <div className="guide_column"></div>
          </div>
        </div>
      </div >
      <div className="code-embed w-embed" dangerouslySetInnerHTML={{
        __html: `<style>
        /* H2 indent */
        span.indent {
          width: var(--column-margin--3);
          display: inline-block;
        }

        /* Anim section arrow hover */
        .anims_arrows_wrap .anims_arrow_hover {
          transition: transform .9s cubic-bezier(0.055, 0.72, 0.165, 1);
          transform: translate(-100%, 0);
        }

        .anims_arrows_wrap .anims_bento_arrow {
          transition: transform .9s cubic-bezier(0.055, 0.72, 0.165, 1);
        }

        .is-arrow-hover:hover .anims_bento_arrow {
          transform: translate(100%, 0);
        }

        .is-arrow-hover:hover .anims_arrow_hover {
          transform: translate(0, 0);
          /* Move to center */
        }

        a[bento-star] {
          transform-style: preserve-3d;
        }
      </style>`
      }} />

      <div data-barba-namespace="home" data-barba="container" className="page_wrap u-theme-dark">


        <main className="page_main">
          <section id="home" className="hero_wrap u-width-full">
            <div className="section_overlay u-width-full">
              <div
                className="section_overlay_vertical u-height-full u-width-full u-flex-horizontal-nowrap u-justify-content-between">
                <div className="section_vert_line u-height-full"></div>
                <div className="section_vert_line u-height-full"></div>
              </div>
              <div
                className="section_overlay_horizontal u-width-full u-height-full u-flex-vertical-nowrap u-justify-content-between">
                <div className="section_hori_line"></div>
                <div className="section_hori_line"></div>
              </div>
            </div>
            <div className="hero_contain u-width-full u-height-full u-flex-vertical-nowrap u-justify-content-between">
              <div className="hero_logo_wrap u-width-full">
                <div className="u-flex-horizontal-nowrap u-justify-content-start u-align-items-center u-width-full u-height-full">
                  <h1 className="hero-heading u-text-style-display u-text-transform-uppercase" style={{ lineHeight: 0.8, textAlign: 'left', marginTop: '15vh' }}>
                    Web<br />Development
                  </h1>
                </div>
                <div data-grid="" className="grid-bg"></div>
              </div>
              <div
                className="hero_bottom_wrap u-width-full u-flex-horizontal-nowrap u-justify-content-between u-align-items-end">
                <div className="hero_bl_wrap u-width-full u-flex-vertical-nowrap u-justify-content-between u-height-full">
                </div>
                <div className="hero_info_wrap u-flex-vertical-nowrap u-justify-content-between u-width-full">
                  <div
                    className="hero_info_icon u-width-full u-height-full u-flex-horizontal-nowrap u-align-items-center u-justify-content-center">
                  </div><svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 14 14" fill="none" data-data-data-bracket=""
                    className="bracket-br">
                    <rect width="14" height="1" transform="matrix(0 -1 -1 0 14 14)" fill="currentColor"></rect>
                    <rect width="14" height="1" transform="matrix(1 0 0 -1 0 14)" fill="currentColor"></rect>
                  </svg><svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 14 14" fill="none" data-data-data-bracket=""
                    className="bracket_-bl">
                    <rect width="14" height="1" transform="matrix(1 0 0 -1 0 14)" fill="currentColor"></rect>
                    <rect width="14" height="1" transform="matrix(0 1 1 0 0 0)" fill="currentColor"></rect>
                  </svg><svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 14 14" fill="none" data-data-data-bracket=""
                    className="bracket-tr">
                    <rect width="14" height="1" transform="matrix(0 1 -1 0 14 0)" fill="currentColor"></rect>
                    <rect width="14" height="1" fill="currentColor"></rect>
                  </svg><svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 14 14" fill="none" data-data-data-bracket=""
                    className="bracket-tl">
                    <rect width="14" height="1" fill="currentColor"></rect>
                    <rect width="14" height="1" transform="matrix(0 -1 1 0 0 14)" fill="currentColor"></rect>
                  </svg>
                  <p className="hero_info_head u-text-style-h4">Building scalable, high-performance digital solutions<br />that drive business growth.</p>
                  <div className="hero_info_about u-width-full">
                    <div className="hero_info_contain u-flex-horizontal-wrap u-justify-content-between u-align-items-start">
                      <div>
                        <p data-data-data-heromono="" className="u-mono">offering</p>
                      </div>
                      <div className="hero_info_strokes_wrap u-flex-vertical-nowrap">
                        <div className="info_stroke">
                          <p data-data-data-heromono="" className="u-mono">architecture</p>
                        </div>
                        <div className="info_stroke info_no_stroke">
                          <p data-data-data-heromono="" className="u-mono">development</p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="hero_info_contain u-flex-horizontal-wrap u-justify-content-between u-align-items-start hero_info_nostroke">
                      <div>
                        <p data-data-data-heromono="" className="u-mono">focus</p>
                      </div>
                      <div className="hero_info_strokes_wrap u-flex-vertical-nowrap">
                        <div className="info_stroke">
                          <p data-data-data-heromono="" className="u-mono">scalability</p>
                        </div>
                        <div className="info_stroke info_no_stroke">
                          <p data-data-data-heromono="" className="u-mono">performance</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Featured Clients Section */}
          <div className="featured-clients-wrapper" style={{ position: 'relative', backgroundColor: '#070707', zIndex: 2 }}>
            <section className="section_home_client section_wrap" style={{ position: 'sticky', top: '0', minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}><div data-home-client-section="" className="featured_client_component"><div className="featured_client_contain u-container"><div data-home-client-title="" data-splitting=""><p className="featured_client is-desktop">In today's digital landscape, your website is your most valuable asset. <br />It is the first touchpoint for your customers and the engine of your growth. <br />We build web solutions that combine aesthetic excellence with technical precision, <br />ensuring your business stands out and scales effortlessly.</p><p className="featured_client is-mobile">In today's digital landscape, your website is your most valuable asset. It is the first touchpoint for your customers and the engine of your growth. We build web solutions that combine aesthetic excellence with technical precision, ensuring your business stands out and scales effortlessly.</p></div></div></div></section>
          </div>

          <StrategySection />





          <MarketingServicesSection />

          <StickyServices />

          <CtaSection />

        </main>
        <Footer />
      </div>
    </>
  );
}
